import { getIntl } from './intl';

const intl = getIntl('getGenderSexText', {
    male: 'Male',
    female: 'Female',
    'non-binary': 'Non-Binary',
    'declined-answer': 'Declined to answer',
});

export type GenderSex = 'male' | 'female' | 'non-binary' | 'declined-answer';

export default function (value: GenderSex | null | undefined): string {
    if (!value) return '';

    return intl(value);
}
